import gql from "graphql-tag";
import { ValidateProductTemplateData } from "@/models/mutations/types/ValidateProductTemplateData";

export const VALIDATE_PRODUCT_TEMPLATE_DATA_MUTATION = gql`
  mutation ValidateProductTemplateData($productData: [ProductPropertyTemplateDataImportInput!]!) {
    validateProductTemplateData(data: $productData) {
      kun
      anr
      type
      additionalInfo
    }
  }
`;

export type ValidateProductTemplateDataResult = ValidateProductTemplateData;
